module.exports = __webpack_public_path__ + "assets/img/cardChallenge.10de1e28.png";